// extracted by mini-css-extract-plugin
export var arrow = "transition-week-switcher-module--arrow--AW9Yx";
export var container = "transition-week-switcher-module--container--sOTGw";
export var navButton = "transition-week-switcher-module--nav-button--772GP";
export var prev = "transition-week-switcher-module--prev--KEj7j";
export var preview = "transition-week-switcher-module--preview--9A2ze";